export var supportedIcons;

(function (supportedIcons) {
  supportedIcons["math"] = "math";
  supportedIcons["writing"] = "writing";
  supportedIcons["study"] = "study";
  supportedIcons["prep"] = "prep";
  supportedIcons["qna"] = "qna";
  supportedIcons["tbs"] = "tbs";
  supportedIcons["tutorsChat"] = "tutorsChat";
})(supportedIcons || (supportedIcons = {}));